/**
 * These are the category values, which come from the beackend (api-v1)
 */
export const Category = Object.freeze({
  ClockedIn: "Clocked-In",
  NotClockedIn: "Not Clocked-In",
  ClockedOut: "Clocked Out",
  Scheduled: "Scheduled",
  MarkedAbsent: "Marked Absent",
  OnBreak: "On Break",
});

/**
 * The translated reason codes into UI text
 */
export const ReasonText = Object.freeze({
  Resigned: "Resigned",
  NoShow: "No Show",
  NoCallNoShow: "No Call No Show",
  Walkoff: "Walkout",
  FamilyEmergency: "Family Emergency",
  Holiday: "Vacation",
  WorksiteClosed: "Worksite closed",
  CancelledByCrewMember: "Cancelled by C.M.",
  Unqualified: "Unqualified",
  Overfill: "Not needed",
  Sick: "Sick",
  Transportation: "No Transportation",
  Default: "ABSENT",
});

/**
 * ReasonCodes, which come from the backend (api-v1)
 */
export const ReasonCode = Object.freeze({
  Resigned: 7,
  NoCallNoShow: 8,
  Walkoff: 9,
  FamilyEmergency: 14,
  Holiday: 15, // Deprecated by BW-2306
  VacationAdvancedWarning: 27,
  WorksiteClosed: 16,
  Sick: 17,
  Transportation: 18,
  CancelledByCrewMember: 19,
  Unqualified: 24,
  Overfill: 25,
  TransportationNoAdvancedWarning: 28,
  SickNoAdvancedWarning: 29,
  FamilyEmergencyNoAdvancedWarning: 30,
  VacationNoAdvancedWarning: 31,
  Absent: 26
});


/**
 * ReasonCodes, which come from the backend (api-v1)
 */
export const ReasonCodesForFiltering = Object.freeze({
  Absent: [ReasonCode.Absent],
  Overfill: [ReasonCode.Overfill],
  Unqualified: [ReasonCode.Unqualified],
  NoCallNoShow: [ReasonCode.NoCallNoShow],
  WorksiteClosed: [ReasonCode.WorksiteClosed],
  CancelledByCrewMember: [ReasonCode.CancelledByCrewMember], // Only including this to not break anything. can delete when removing split TODO(BW-1818)
  Resigned: [ReasonCode.Resigned, ReasonCode.Walkoff],
  Sick: [ReasonCode.Sick, ReasonCode.SickNoAdvancedWarning],
  Vacation: [ReasonCode.VacationAdvancedWarning, ReasonCode.VacationNoAdvancedWarning],
  FamilyEmergency: [ReasonCode.FamilyEmergency, ReasonCode.FamilyEmergencyNoAdvancedWarning],
  Transportation: [ReasonCode.Transportation, ReasonCode.TransportationNoAdvancedWarning],
});


/**
 * This is used to translate backend values to values to be used in the UI
 */
export const CATEGORY_MAP = {
  [Category.NotClockedIn]: {
    text: "Not clocked in",
    class: "not-clocked-in",
  },
  [Category.ClockedIn]: { text: "Clocked in", class: "clocked-in" },
  [Category.ClockedOut]: { text: "Clocked out", class: "clockedout" },
  [Category.Scheduled]: { text: "Scheduled", class: "scheduled" },
  [Category.OnBreak]: { text: "On Break", class: "clocked-in" },
};

/**
 * This is used to translate backend values to values to be used in the UI
 */
export const REASON_MAP = {
  15: { text: ReasonText.Holiday, class: "worksite-excused" }, // Unused
  24: { text: ReasonText.Unqualified, class: "unexcused" }, // Unused
  25: { text: ReasonText.Overfill, class: "worksite-overfill" },
  
  // Mark Absent Not Informed In Advance reason values + text + class
  7: { text: ReasonText.Resigned, class: "unexcused" },
  14: { text: ReasonText.FamilyEmergency, class: "unexcused" }, // We reuse the unexecused class, but it is an excused absence
  16: { text: ReasonText.WorksiteClosed, class: "worksite-excused" },
  17: { text: ReasonText.Sick, class: "unexcused" }, // We reuse the unexecused class, but it is an excused absence
  18: { text: ReasonText.Transportation, class: "unexcused" }, // We reuse the unexecused class, but it is an excused absence
  19: { text: ReasonText.CancelledByCrewMember, class: "unexcused" },
  26: { text: ReasonText.Default, class: "unexcused" },
  27: { text: ReasonText.Holiday, class: "unexcused" }, // We reuse the unexecused class, but it is an excused absence
  
  // Mark Absent Not Informed In Advance reason values + text + class
  8: { text: ReasonText.NoCallNoShow, class: "unexcused" },
  9: { text: ReasonText.Walkoff, class: "unexcused" },
  28: { text: ReasonText.Transportation, class: "unexcused" },
  29: { text: ReasonText.Sick, class: "unexcused" }, // Illness, medical issue, or injury
  30: { text: ReasonText.FamilyEmergency, class: "unexcused" }, 
  31: { text: ReasonText.Holiday, class: "unexcused" }, 
  Default: { text: ReasonText.Default, class: "unexcused" }, // This default value is being used as a fallback just in case there are gaps in our system, but ideally it should not surface
};
